module.exports = "../dist/img/logo.23af.png";